import { render, staticRenderFns } from "./BrandInput.vue?vue&type=template&id=0bf4621e&scoped=true"
import script from "./BrandInput.vue?vue&type=script&lang=js"
export * from "./BrandInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf4621e",
  null
  
)

export default component.exports